module.exports = __webpack_public_path__ + "img/hr-wooden-particle-11.6cf01cc3.png";